import request from "root/js/request";

// Название не по правилам, ниже просто сделаю каноничный вариант
// Получаем историю всех запросов
export const getKeywordsPosition = async ({ ordering, limit, offset, ...rest }) => {
  const response = await request({
    url: `/parsers/keywords_position/`,
    method: "get",
    params: {
      ordering,
      limit,
      offset,
      ...rest,
    },
  });
  // Зачем возвращать ответ, надо возвращать данные
  return response;
};

//
export const getParsersKeywordsPosition = async ({ ordering, limit, offset, ...rest }) => {
  const response = await request({
    url: `/parsers/keywords_position/`,
    method: "get",
    params: {
      ordering,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
